import {
  AllClassifedsResType,
  CategoryType,
  ClassifiedType,
  SellerProfileByTokenResType,
  SellerProfileResType,
  AdCountType
} from "../../types/main-types/mainTypes";
import { API_ROUTES, BASE_URL } from "../apiRoutes";
import axiosInstance from "../axiosInstance";

const CLASSIFIEDS_URL = API_ROUTES.MAIN;
const SELLER_URL = API_ROUTES.SELLER;

// Get the token dynamically (in case it changes)
const getToken = () => sessionStorage.getItem("authToken");

export const getVehicleCategoryAdCount = async (): Promise<AdCountType[]> => {
  try {
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/get-ads-count-per-category`
    );

    return response.data.data.Categories;
  } catch (error) {
    console.error("Error fetching vehicle categories:", error);
    throw error;
  }
};

export const getAllLocations = async (): Promise<string[]> => {
  try {
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/read-locations`
    );

    return response.data.data.Locations;
  } catch (error) {
    console.error("Error fetching locations:", error);
    throw error;
  }
};

export const getAllClassifieds = async (
  payload: any
): Promise<AllClassifedsResType> => {
  try {
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/read`,
      payload
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching classifieds:", error);
    throw error;
  }
};

export const getClassifiedById = async (
  payload: any
): Promise<ClassifiedType> => {
  try {
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/get`,
      payload
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching classified:", error);
    throw error;
  }
};

export const getSellerProfileById = async (
  payload: any
): Promise<SellerProfileResType> => {
  try {
    const response = await axiosInstance.post(
      `${SELLER_URL}/read-public-profile`,
      payload
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching seller profile:", error);
    throw error;
  }
};

export const getPresignedUrl = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/get-image-upload-presigned-urls`,
      payload,
      configs
    );
    return response.data.data;
  } catch (error) {
    console.error("Error getting pre signed url:", error);
    throw error;
  }
};

export const putImgWithPresignedUrl = async (
  url: string,
  payload: any,
  configs: any
): Promise<any> => {
  try {
    const response = await axiosInstance.put(url, payload, configs);
    return response.data.data;
  } catch (error) {
    console.error("Error putting image with pre signed url:", error);
    throw error;
  }
};

export const addClassified = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/add`,
      payload,
      configs
    );
    return response.data.data;
  } catch (error) {
    console.error("Error adding classified:", error);
    throw error;
  }
};

export const updateClassified = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/update`,
      payload,
      configs
    );
    return response.data.data;
  } catch (error) {
    console.error("Error updating classified:", error);
    throw error;
  }
};

export const getSellerProfileByToken = async (
  payload: any
): Promise<SellerProfileByTokenResType> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${SELLER_URL}/read-private-profile`,
      payload,
      configs
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching seller profile:", error);
    throw error;
  }
};

export const showClassified = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/show`,
      payload,
      configs
    );
    return response.data;
  } catch (error) {
    console.error("Error calling show classified :", error);
    throw error;
  }
};

export const hideClassified = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/hide`,
      payload,
      configs
    );
    return response.data;
  } catch (error) {
    console.error("Error calling hide classified :", error);
    throw error;
  }
};

export const boostPremiumClassified = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/premium-boost`,
      payload,
      configs
    );
    return response.data;
  } catch (error) {
    console.error("Error calling hide classified :", error);
    throw error;
  }
};

export const boostStandardClassified = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/standard-boost`,
      payload,
      configs
    );
    return response.data;
  } catch (error) {
    console.error("Error calling hide classified :", error);
    throw error;
  }
};

export const deleteStandardClassified = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${CLASSIFIEDS_URL}/delete`,
      payload,
      configs
    );
    return response.data;
  } catch (error) {
    console.error("Error calling hide classified :", error);
    throw error;
  }
};

export const getAllMasterData = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/master-data/read`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching master data:", error);
    throw error;
  }
};
